var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tableToShow === 'enrollments')?_c('bpc-enrollment-table'):_vm._e(),(_vm.tableToShow === 'waiting-list')?_c('bpc-waiting-list-table'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }